"use client";

import React from "react";
import {useTranslation} from "react-i18next";
import {
   EMPTY_CAPTIONS_TRACK_SRC,
   getMediaTrackSrcLang,
} from "@/utils/common/mediaTrackLanguage";

const InlineAudioPreview: React.FC<{url: string; mimeType: string; fileName: string}> = ({
   url,
   mimeType,
   fileName,
}) => {
   const {t, i18n} = useTranslation("ask");
   const captionSrcLang = getMediaTrackSrcLang(i18n);
   return (
      <div className="flex flex-col items-center justify-center h-full gap-4 p-6">
         <p className="text-sm text-700 truncate max-w-full" title={fileName}>
            {fileName}
         </p>
         <audio controls className="w-full max-w-md" preload="metadata">
            <source src={url} type={mimeType} />
            <track
               kind="captions"
               src={EMPTY_CAPTIONS_TRACK_SRC}
               srcLang={captionSrcLang}
               label={t("a11y.captionsUnavailable")}
            />
            {t("preview.audioUnsupported")}
         </audio>
      </div>
   );
};

export default InlineAudioPreview;
